import Crop from './Crop';
import bus, { EVENTS } from './bus';

export default class ImageCrops extends PIXI.Container {
  constructor(crops, viewport) {
    super();
    this.viewport = viewport;
    this.crops = crops;
    this.drawCrops();

    bus.$on(EVENTS.TOGGLE_SKU_BY_TYPE, () => this.handleToggleSkuByType());
    this.handleToggleSkuByType();

    document.addEventListener('keydown', this.listenKeyboardEvents);

    this.on('removed', () => {
      document.removeEventListener('keydown', this.listenKeyboardEvents);
    });
  }

  handleToggleSkuByType() {
    const {
      show_meta_sku, show_normal_sku, show_non_sku, show_unrecognized_sku, hide_competitor_sku
    } = bus;

    const { children } = this;

    const selected = children.find(item => item.is_selected);
    // Un-select selected crop before filtering
    if (selected) {
      selected.click();
    }

    children.forEach((acc) => {
      acc.visible = true;
    });

    if (!show_meta_sku) {
      children
        .filter(item => item.crop.is_meta)
        .forEach((acc) => {
          acc.visible = false;
        });
    }

    if (!show_unrecognized_sku) {
      children
        .filter(item => item.crop.is_unrecognized)
        .forEach((acc) => {
          acc.visible = false;
        });
    }

    if (hide_competitor_sku) {
      children
        .filter(item => item.crop.is_competitor)
        .forEach((acc) => {
          acc.visible = false;
        });
    }

    if (!show_normal_sku) {
      children
        .filter(item => item.crop.is_sku && !item.crop.is_meta)
        .forEach((acc) => {
          acc.visible = false;
        });
    }

    if (!show_non_sku) {
      children
        .filter(item => item.crop.is_nonSku)
        .forEach((acc) => {
          acc.visible = false;
        });
    }
  }

  listenKeyboardEvents = (e) => {
    const visible_children = this.children.filter(item => item.visible);

    let index = visible_children.findIndex(item => item.is_selected);

    let child = null;

    switch (e.code) {
      case 'ArrowLeft':
        index -= 1;
        child = visible_children[index];
        break;
      case 'ArrowRight':
        index += 1;
        child = visible_children[index];
        break;
      case 'Escape':
        child = visible_children.find(item => item.is_selected);

        break;

      default:

        break;
    }

    if (!child) return;

    child.click();
  }

  drawCrops() {
    this.crops.forEach((crop) => {
      this.addChild(new Crop(crop, this.viewport));
    });
  }
}
